import React from 'react';
import AuthImage from '../../images/illustration-authentication.svg?react';
import ShellLogo from '../../images/shell.svg';
import {
  ImageContainer,
  MainBody,
  ShellLogoContainer,
  SubContent,
  ShellHeader,
  ShellFooter,
  StatusCode,
  UserMessage,
} from './NotAuthenticated.styled';

const NotAuthenticated: React.FC = () => {
  return (
    <MainBody data-testid="NotAuthenticated">
      <ShellLogoContainer>
        <img src={ShellLogo} alt='' />
        <SubContent>
          <ShellHeader>Shell</ShellHeader>
          <ShellFooter>Interconnector Trading</ShellFooter>
        </SubContent>
      </ShellLogoContainer>

      <ImageContainer>
        <AuthImage />
      </ImageContainer>

      <StatusCode>401</StatusCode>
      <UserMessage>
        Sorry, your user details is not set up with the relevant roles for you
        to view this page. <br />
        To request access, please email the ITA team{' '}
        <b>GX-LON-YR-ITA-SUPPORT@shell.com </b> <br />
        citing the reason(s) for needing access.
      </UserMessage>
    </MainBody>
  );
};

export default NotAuthenticated;
